import { Component, OnInit } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { PagesFilesPagesComponent } from '@client/app/components/pages/files/pages/pages.component';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'inventory-dialogs-content-links',
    templateUrl: './links.html',
    standalone: false,
})
export class InventoryDialogsContentLinksComponent extends BaseContainerComponentController implements OnInit {
    links: any = [];
    domain_id: number = 0;
    scanDocuments: boolean = false;
    tabs: any[] = [];
    export: any[] = [];
    exports: any[] = [];
    promise: Promise<any> | undefined;

    constructor (
        private linksRepoService: LinksRepoService,
        private monEventService: MonEventService,
        private translateService: TranslateService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.links = [];
        this.search = '';
        this.domain_id = this.sessionService.domain?.id || 0;
        this.scanDocuments = this.sessionService.domain?.scan?.scan_documents || false;
        this.setupTabs();
        this.getPage();
        this.export = [
            {
                name: this.translateService.getString('Internal Export'),
                data: {
                    category: 'inventory_links',
                    category_ref: 'internal',
                },
            },
        ];

        this.exports = [
            {
                name: this.translateService.getString('External Export'),
                data: {
                    category: 'inventory_links',
                    category_ref: 'external',
                },
            },
        ];
    }

    setupTabs (): void {
        this.tabs = [
            {
                name: this.translateService.getString('Internal'),
                value: 'internal',
            },
            {
                name: this.translateService.getString('External'),
                value: 'external',
            },
        ];
        this.activeTab = this.tabs[0].value;
    }

    override getPage = (): void => {
        const params = {
            page: this.page,
            page_size: this.pageSize,
            search: this.search ?? '',
            type: 'link',
            relation: this.activeTab,
            page_fixed: false,
        };

        this.promise = this.linksRepoService.getAll(params).then((data: any) => {
            this.links = data;
        }, () => {});
    };

    openDialog (link: any, type?: string): void {
        const params = {
            body: PagesFilesPagesComponent,
            size: 'lg',
            data: {
                link: link,
                domainId: this.domain_id,
                active: 'links',
                icon: this.pipeService.get('monIcons')(['INVENTORY', 'DIALOGS', 'LINKS']),
                type: type,
            },
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
